<template>
  <slot v-bind="{ showThumbnails }"></slot>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      showThumbnails: false
    };
  },
  computed: {},
  methods: {},
  mounted() {}
};
</script>

<style lang="scss" scoped></style>
